<template lang="pug">
  form.navbar-search(action="/search", ref="searchForm")
    .navbar-search__input-wrapper
      .input.input--text
        label.u-sr-only(for="q") Search
        input.navbar-search__field(
          aria-label="Search"
          type="text"
          ref="input"
          name="q"
          v-model="searchValue"
          autocomplete="off"
          placeholder="Search Products"
          @keydown.tab="tab"
          @keydown.escape="hide"
          @focus="$emit('open-results')"
        )
        icon-button.navbar-search__clear(
          icon="close"
          size="10px"
          @click="clearSearch"
        )
        navbar-search-results(
          ref="searchResults"
          :collection-handle="allProductsHandle"
          :search="getSearchValue"
          :suggestions="suggestedSearches"
          @selected="suggestionSelected"
        )
    icon-button.navbar-search__submit.navbar-search__submit-icon(
      v-if="$mq === 'mobile'"
      icon="chevron-right"
      size="10px"
      :disabled="isDisabled"
      @click="searchClick"
    )
    primary-button.navbar-search__submit(
      v-else
      label="Search"
      @click="searchClick"
      :disabled="isDisabled"
      :test="searchValue"
    )
</template>

<script>
  import { allProductsHandle } from 'scripts/config/collections.js';

  import PrimaryButton from 'scripts/components/buttons/PrimaryButton.vue';
  import NavbarSearchResults from 'scripts/components/navigation/NavbarSearchResults.vue';
  import IconButton from 'scripts/components/buttons/IconButton.vue';

  export default {
    name: 'NavbarSearch',
    components: {
      PrimaryButton,
      NavbarSearchResults,
      IconButton,
    },
    props: {
      value: String,
      placeholder: {
        type: String,
        default: 'Search products',
      },
      suggestedSearches: {
        type: Array,
        default: () => [],
      }
    },
    data () {
      return {
        searchValue: this.value,
        tabbingOut: false,
        show: false,
        allProductsHandle: allProductsHandle,
      };
    },
    watch: {
      searchValue () {
        this.$emit('input', this.searchValue);
      },
    },
    mounted() {
      this.$refs.input.focus();
    },
    computed: {
      isDisabled() {
        return !this.searchValue || this.searchValue.length <= 0;
      },
      getSearchValue() {
        return this.searchValue;
      },
      searchPlaceholder () {
        return (this.$mq === 'tablet') ? 'Search' : this.placeholder;
      },
    },
    methods: {
      suggestionSelected (suggestion) {
        this.$refs.searchBox.update(suggestion);
      },
      clearSearch () {
        this.searchValue = '';
      },
      update (newVal) {
        this.searchValue = newVal;
        this.$refs.input.focus();
      },
      tab () {
        this.tabbingOut = true;
      },
      focus () {
        this.$refs.input.focus();
      },
      searchClick () {
        if (!this.show) {
          if (this.$mq !== 'mobile') this.show = true;
          this.$nextTick(() => this.focus());
        }

        if ((this.show || this.$mq === 'mobile') && this.searchValue !== '') {
          this.$refs.searchForm.submit();
        }
      },
      hide () {
        if (this.searchValue === '') {
          if (this.$mq !== 'mobile') this.show = false;
          this.$emit('close-results');
        }
      },
    },
  };
</script>

<style lang="scss">
  .navbar-search {
    position: relative;
    margin: auto;
    max-width: 665px;
    display: flex;
    align-items: center;

    .navbar-search__input-wrapper {
      position: relative;
      margin-bottom: 0;
      flex-grow: 1;

      .input,
      input {
        margin-bottom: 0;
      }
    }

    .navbar-search__submit-icon {
      padding: 14px 14px 18px;
      background-color: $color-indigo;

      .icon {
        fill: $color-white;
      }
    }

    .navbar-search__clear {
      position: absolute;
      top: 50%;
      right: 9px;
      transform: translateY(-50%);
    }

    &__submit {
      margin-left: 10px;
    }

    &__field {
      padding: 10px 38px 10px 6px;
      width: 100%;
      font-size: rem(16);
      line-height: 1.2;
    }

    &::v-deep .button:hover .icon {
      fill: $color--link;
    }
  }
</style>
